export const sprPrivacyText = () => {
  return `HP respects your privacy.
        <br /> For more information regarding HP's privacy policies and practices, please visit our
        <a
          target={'_blank'}
          rel={'noreferrer'}
          href="https://www.hp.com/us-en/privacy/privacy.html"
        >
          Privacy Statement
        </a>`
}
